import { __extends } from "tslib";
import ModelBase from '../ModelBase';
var FileDescriptorBase = /** @class */ (function (_super) {
    __extends(FileDescriptorBase, _super);
    function FileDescriptorBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fileDescriptorId = null;
        _this.fileHash = "";
        _this.storageKey = "";
        _this.fileDataId = null;
        _this.fileName = "";
        return _this;
    }
    FileDescriptorBase.prototype.addBusinessRules = function (rules) {
        _super.prototype.addBusinessRules.call(this, rules);
    };
    FileDescriptorBase.prototype.toString = function () {
        return this.fileName && this.fileName.length > 0 ? this.fileName : "File Descriptor";
    };
    return FileDescriptorBase;
}(ModelBase));
export { FileDescriptorBase };
